import { HttpResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';

export class DownloadService {
    static saveBlobToFile(blob: Blob, filename: string): void {
        try {
            saveAs(blob, filename);
        } catch (e) {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        }
    }

    static getFileName(resp: HttpResponse<Blob>, defaultValue: string) {
        if (!resp) {
            return defaultValue;
        }

        const contentDisposition = resp.headers.get('content-disposition') || '';
        let fileName = defaultValue;
        const filenameMatch =
            /filename\*=UTF-8''([^;\n\r]+)/i.exec(contentDisposition) ||
            /filename="?([^";]+)"?/i.exec(contentDisposition);
        if (filenameMatch && filenameMatch[1]) {
            try {
                fileName = decodeURIComponent(filenameMatch[1]);
            } catch (e) {
                fileName = filenameMatch[1];
            }
        }

        return fileName;
    }
}
